import type * as types from './types';

const policyAreas: types.PolicyAreas = {
  page: 'Politikbereiche',
  pathname: '/policy-areas',
  permissions: {
    createNew: true,
    edit: true,
    remove: true,
    view: true,
    addFieldsInside: true,
    removeFieldsInside: true,
    assign: true,
    printReport: true,
    inviteNewUsers: 'empty',
    dragFields: 'empty',
    freezeYears: 'empty',
    freezeYearsGoals: 'empty',
  },
};

const priorities: types.Priorities = {
  page: 'Ambitionen',
  pathname: '/priorities',
  permissions: {
    createNew: true,
    edit: true,
    remove: true,
    view: true,
    addFieldsInside: true,
    removeFieldsInside: true,
    assign: true,
    printReport: true,
    inviteNewUsers: 'empty',
    dragFields: 'empty',
    freezeYears: 'empty',
    freezeYearsGoals: 'empty',
  },
};

const people: types.People = {
  page: 'Personen',
  pathname: '/people',
  permissions: {
    createNew: true,
    edit: true,
    remove: true,
    view: true,
    addFieldsInside: 'empty',
    removeFieldsInside: 'empty',
    assign: 'empty',
    printReport: 'empty',
    inviteNewUsers: 'empty',
    dragFields: 'empty',
    freezeYears: 'empty',
    freezeYearsGoals: 'empty',
  },
};

const agencies: types.Agencies = {
  page: 'Abteilungen',
  pathname: '/agencies',
  permissions: {
    createNew: true,
    edit: true,
    remove: true,
    view: true,
    addFieldsInside: 'empty',
    removeFieldsInside: true,
    assign: true,
    printReport: true,
    inviteNewUsers: 'empty',
    dragFields: true,
    freezeYears: 'empty',
    freezeYearsGoals: 'empty',
  },
};

const divisions: types.Divisions = {
  page: 'Bereiche/Diensteinheiten',
  pathname: '/divisions',
  permissions: {
    createNew: true,
    edit: true,
    remove: true,
    view: true,
    addFieldsInside: true,
    removeFieldsInside: true,
    assign: true,
    printReport: true,
    inviteNewUsers: 'empty',
    dragFields: true,
    freezeYears: 'empty',
    freezeYearsGoals: 'empty',
    freezeEdit: true,
    freezeAssign: true,
    freezeCreateNew: true,
    freezeRemove: true,
  },
};

const profile: types.Profile = {
  page: 'Mein Profil',
  pathname: '/profile',
  permissions: {
    createNew: 'empty',
    edit: true,
    remove: 'empty',
    view: true,
    addFieldsInside: 'empty',
    removeFieldsInside: 'empty',
    assign: 'empty',
    printReport: 'empty',
    inviteNewUsers: 'empty',
    dragFields: 'empty',
    freezeYears: 'empty',
    freezeYearsGoals: 'empty',
  },
};

const years: types.Years = {
  page: 'Jahre',
  pathname: '/years',
  permissions: {
    createNew: true,
    edit: 'empty',
    remove: true,
    view: true,
    addFieldsInside: 'empty',
    removeFieldsInside: 'empty',
    assign: 'empty',
    printReport: 'empty',
    inviteNewUsers: 'empty',
    dragFields: 'empty',
    freezeYears: true,
    freezeYearsGoals: true,
  },
};

const reports: types.Reports = {
  page: 'Reports',
  pathname: '/reports',
  permissions: {
    createNew: 'empty',
    edit: 'empty',
    remove: 'empty',
    view: true,
    addFieldsInside: 'empty',
    removeFieldsInside: 'empty',
    assign: 'empty',
    printReport: true,
    inviteNewUsers: 'empty',
    dragFields: 'empty',
    freezeYears: 'empty',
    freezeYearsGoals: 'empty',
  },
};

const users: types.Users = {
  page: 'Benutzer',
  pathname: '/users',
  permissions: {
    createNew: 'empty',
    edit: 'empty',
    remove: 'empty',
    view: 'empty',
    addFieldsInside: 'empty',
    removeFieldsInside: 'empty',
    assign: 'empty',
    printReport: 'empty',
    inviteNewUsers: true,
    dragFields: 'empty',
    freezeYears: 'empty',
    freezeYearsGoals: 'empty',
  },
};

const admin: types.Page[] = [
  policyAreas,
  priorities,
  people,
  agencies,
  divisions,
  profile,
  years,
  reports,
  users,
];

export default admin;
